import gql from 'graphql-tag'

export const GetProjectStatisticsQuery = gql`
  query GetProjectStatistics($input: ProjectStatisticsInput!) {
    stats: getProjectsStatistics (input: $input) {
      projectId
      dateKey
      chatsAmount
      contactsAmount
    }
  }
`
